// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__ptaIO","plus":"styles_plus__N3dUT","key":"styles_key__fM7gH"};